module.exports = __webpack_public_path__ + "img/numero3.cfce6b59.svg";